<template>
  <v-list-tile
    avatar
    class="item d-file-item"
    :class="{
      pending: item.state.equals(FILE_STATES.pending),
      downloading: item.state.equals(FILE_STATES.downloading),
      canceled: item.state.equals(FILE_STATES.canceled),
      error: item.state.equals(FILE_STATES.error),
      completed: item.state.equals(FILE_STATES.completed)
    }" >
    <v-list-tile-avatar>
      <span class="icon icon-state progress">
        <v-icon v-if="completed">
          file_download
        </v-icon>
        <v-progress-circular v-else-if="item.state.equals(FILE_STATES.completed)" :size="40" :value="100" :rotate="270" class="primary--text">
          {{100}}
        </v-progress-circular>
        <v-progress-circular v-else :size="40" :value="item.progress? parseInt(item.progress) : 0" :rotate="270" :indeterminate="item.state.equals(FILE_STATES.pending)" class="primary--text">
          {{item.progress && parseInt(item.progress) !== 0 ? parseInt(item.progress) : ''}}
        </v-progress-circular>
      </span>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title>
        <span class="file-title name" >{{item.file.name}}</span>
      </v-list-tile-title>
      <v-list-tile-sub-title v-if="item.state.equals(FILE_STATES.downloading)">
        <span class="file-title name">{{$tf('Your download is being prepared')}}<animated-ellipsis/></span>
      </v-list-tile-sub-title>
      <v-list-tile-sub-title v-if="item.state.equals(FILE_STATES.completed) && !completed">
        <span class="file-title name">{{$tf('Download started')}}</span>
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action class="actions">
      <v-btn
        ripple
        @click="action"
        class="action"
        :class="{
          'success': actionIcon === 'check',
          'info': actionIcon === 'refresh',
          'error': actionIcon === 'clear'
        }"
        icon>
        <v-icon>{{actionIcon}}</v-icon>
      </v-btn>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
  import Color from '~/helpers/color.js'
  import $state from '../download-state.js'
  import FILE_STATES from '../file-states.js'
  import FormatBadge from '~/components/common/files/FormatBadge.vue'
  import AnimatedEllipsis from '~/components/common/AnimatedEllipsis.vue'
  import { zipFiles } from '../methods/download'

export default {
    name: 'd-file-item',
    components: {
      AnimatedEllipsis,
      FormatBadge
    },
    props: {
      item: {
        type: Object,
        required: true
      },
      uid: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        'FILE_STATES': FILE_STATES,
        completed: false
      }
    },
    mounted () {
      if (this.itemState.equals(FILE_STATES.completed)) {
        setTimeout(() => {
          this.completed = true
        }, 3000)
      }
    },
    watch: {
      itemState (val) {
        if (val.equals(FILE_STATES.completed)) {
          setTimeout(() => {
            this.completed = true
          }, 3000)
        }
      }
    },
    computed: {
      itemState () {
        return this.item.state
      },
      extension () {
        let pieces = this.item.file.name.split('.')

        return pieces.length > 1 ? pieces[pieces.length - 1].toUpperCase() : '?'
      },
      actionIcon () {
        let action

        switch (this.item.state.id) {
          case 'pending':
          case 'downloading':
            action = 'clear'
            break
          case 'canceled':
          case 'error':
            action = 'refresh'
            break
          case 'completed':
            action = 'check'
            break
        }

        return action
      },
      action () {
        return event => {
          switch (this.item.state.id) {
            case 'pending':
            case 'downloading':
              $state.abortDownload(this.uid)
              break
            case 'canceled':
            case 'error':
              this.retryDownload()
              break
          }
        }
      }
    },
    methods: {
      colorFromExtension: Color.fromExtension,
      colorFromName: Color.fromName,
      downloadFile () {
        $state.downloadFile(this.uid).catch(e => {
          console.debug(e)
        }
        )
      },
      retryDownload () {
        delete $state.files[this.uid]
        delete $state.filesByState[FILE_STATES.canceled][this.uid]
        delete $state.filesByState[FILE_STATES.error][this.uid]
        if (this.item.file.zipFileIDs) {
          zipFiles(this.item.file.zipFileIDs, this.item.file.excludeViewer, this.item.file.includeRenderedImages).catch(e => console.error(e))
        } else {
          this.$download({ file: this.item.file }).catch(e => console.error(e))
        }
      },
      updateState (nextState) {
        if (nextState !== undefined) {
          $state.updateFileState(this.uid, nextState)
        }
      }
    }
  }
</script>
<style lang="scss">
  .d-file-item {
    &.item a {
      padding: 0 0 0 .5rem;
    }

    &.uploading {
      .avatar {
        padding-left: .5rem;
      }
    }

    .list__tile__content {
      padding-left: .25rem;
    }

    .progress-circular__info {
      font-size: 16px;
    }

    .card-format {
      max-width: 60px;
      border-radius: 2px;
      padding: 2px 6px;
      color: white;
      text-shadow: 0px 1px 1px #333;
      text-align: center;

      .format {
        width: 42px;
      }
    }

    .icon-state {
      color: white;
    }

    .actions {
      justify-content: center !important;

      .action {
        color: white;
        width: 26px;
        height: 26px;
      }
    }

    .file-title {
      display: inline-block;
      line-height: 2rem;
      vertical-align: middle;

      &.name {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 250px;
      }

      &.size {
        display: inline;
      }
    }

    .extension {
      font-size: 1rem;
    }

    .progress {
      background-color: transparent;
      position: relative;
      color: rgba(0,0,0,0.54);

      .wrapper {
        position: absolute;
        left: -6px;
        top: -6px;
        right: -6px;
        bottom: -6px;

        .progress-circle {
          transform: rotate(-90deg);

          .meter {
            stroke: #e6e6e6;
            fill: none;
          }
          .value {
            stroke: #f77a52;
            fill: none;
            stroke-dasharray: 337;
            transition: .1s linear;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/plugins/uploader/components/DFileItem.vue